import { getRadiographySources } from '../../api/activities-nim';
import { RadiographySourceReadDTO } from '../../api/dto';
import { Locale } from '../../i18n/Locale';
import { FetchUseCase } from '../fields/AsyncAutocompleteElement';
import { AsyncAutocompleteFormElement, TFormElement } from '../types';
import { UiSchemaType } from '../UiSchemaType';

const radiographySourceTypeProperties = (locale: Locale): AsyncAutocompleteFormElement['typeProperties'] => ({
    idField: 'id',
    fetchOptions: (searchTerm, exactId, idField, values) => getRadiographySources(),
    fetchUseCases: [FetchUseCase.ON_OPEN, FetchUseCase.ON_LOAD],
    getOptionLabel: (value: RadiographySourceReadDTO) => `${value.sourceLabel ?? ''} - ${value.isotope ?? ''}`,
    multiple: false,
});

interface RadiographySourceSchemaParameters extends Pick<AsyncAutocompleteFormElement, 'path' | 'label' | 'required'> {}

export const radiographySourceSchema = (
    { path, label, required }: RadiographySourceSchemaParameters,
    locale: Locale
): TFormElement => ({
    type: UiSchemaType.AUTOCOMPLETE_ASYNC,
    path,
    label,
    required,
    typeProperties: radiographySourceTypeProperties(locale),
});
